import type { BasicResult } from '/@/api/model/baseModel';
import type { getMenuListResultModel, RouteItem, MenuParams } from './model/menuModel';
import { defHttp } from '/@/utils/http/axios';
// import { menuList } from './menulist';

enum Api {
  GetMenuList = '/partner/user/routers',
  List = '/system/menu/list',
  Menu = '/system/menu/',
}

/**
 * @description: Get user menu based on id
 */

export const getMenuList = async () => {
  const res = await defHttp.get({ url: Api.GetMenuList });
  res.forEach((ele) => {
    ele.children?.forEach((e) => {
      if (e.hidden) {
        e.meta.hideMenu = e.hidden;
      }
    });
  });

  // res.data.push({
  //   path: '/link',
  //   name: 'Link',
  //   component: 'LAYOUT',
  //   meta: {
  //     icon: 'ion:tv-outline',
  //     title: 'routes.demo.iframe.frame',
  //     hideMenu: true,
  //   },
  //   children: [
  //     {
  //       path: 'panel/:id',
  //       name: 'Panel',
  //       component: '',
  //       meta: {
  //         title: '监控面板大屏',
  //         frameSrc: import.meta.env.DEV
  //           ? 'https://127.0.0.1:5173/iot-ui#/chart/home'
  //           : 'http://10.2.0.221/iot-ui/#/chart/home',
  //       },
  //     },
  //   ],
  // });
  return MapArr(res);
};

export const getList = (params?: MenuParams) =>
  defHttp.get<getMenuListResultModel>({ url: Api.List, params });

export const deleteList = (id: number) => defHttp.delete<BasicResult>({ url: Api.Menu + id });
export const addMenu = (params) => defHttp.post<BasicResult>({ url: Api.Menu, params });
export const setMenu = (params) => defHttp.put<BasicResult>({ url: Api.Menu, params });
function MapArr(data: RouteItem[]) {
  // 如果有子路由 重定向到第一个子路由
  return data.map((item) => {
    let redirect = '';
    item.meta && (item.meta.hideChildrenInMenu = true);
    if (item.children?.length) {
      redirect = item.path + '/' + item.children[0].path;
      item.meta && (item.meta.hideChildrenInMenu = false);
    }
    return { ...item, redirect };
  });
}
